export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { name: 'الرئيسية', href: '#' },
    { name: 'الخدمات', href: '#services' },
    { name: 'العملاء', href: '#clients' },
    { name: 'تواصل معنا', href: '#contact' }
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', href: '#', color: 'hover:text-pink-500' },
    { icon: 'ri-twitter-x-line', href: '#', color: 'hover:text-blue-400' },
    { icon: 'ri-linkedin-line', href: '#', color: 'hover:text-blue-600' },
    { icon: 'ri-tiktok-line', href: '#', color: 'hover:text-gray-900' },
    { icon: 'ri-youtube-line', href: '#', color: 'hover:text-red-600' }
  ];

  return (
    <footer id="contact" className="relative bg-gradient-to-br from-slate-50 via-gray-50 to-slate-100 text-gray-800 overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 w-96 h-96 bg-orange-400/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo and Description */}
          <div className="text-center md:text-right">
            <div className="w-32 h-32 mx-auto md:mx-0 md:mr-auto mb-6 bg-white rounded-2xl p-4 shadow-lg">
              <img 
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/285b7640542be24b8fdcf99e084fae95.png" 
                alt="شعار المؤسسة" 
                className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
              />
            </div>
            <h3 className="text-2xl font-bold mb-4 text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
              مؤسسة إدارة حسابات التواصل الاجتماعي
            </h3>
            <p className="text-gray-600 leading-relaxed" style={{ fontFamily: 'Cairo, sans-serif' }}>
              نقدم حلولاً رقمية متكاملة لإدارة حسابات التواصل الاجتماعي بأعلى معايير الجودة والاحترافية
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center">
            <h4 className="text-xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
              روابط سريعة
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-gray-600 hover:text-orange-500 hover:underline transition-all duration-300 text-lg inline-block hover:translate-x-2"
                    style={{ fontFamily: 'Cairo, sans-serif' }}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="text-center md:text-left">
            <h4 className="text-xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Cairo, sans-serif' }}>
              تواصل معنا
            </h4>
            <div className="space-y-4">
              <div className="flex items-center justify-center md:justify-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 text-white rounded-full">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <span className="text-gray-600" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  info@socialmedia.com
                </span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-blue-600 text-white rounded-full">
                  <i className="ri-phone-line text-xl"></i>
                </div>
                <span className="text-gray-600" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  +966 50 123 4567
                </span>
              </div>
              <div className="flex items-center justify-center md:justify-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-500 text-white rounded-full">
                  <i className="ri-map-pin-line text-xl"></i>
                </div>
                <span className="text-gray-600" style={{ fontFamily: 'Cairo, sans-serif' }}>
                  الرياض، المملكة العربية السعودية
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Social Media Links */}
        <div className="border-t border-gray-300 pt-8 mb-8">
          <div className="flex items-center justify-center gap-4">
            {socialLinks.map((social, index) => (
              <a
                key={index}
                href={social.href}
                className={`w-12 h-12 flex items-center justify-center bg-white hover:bg-gray-100 text-gray-700 rounded-full transition-all duration-300 hover:scale-110 shadow-md ${social.color}`}
              >
                <i className={`${social.icon} text-2xl`}></i>
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-300 pt-8 text-center">
          <p className="text-gray-600 text-lg mb-4" style={{ fontFamily: 'Cairo, sans-serif' }}>
            © {currentYear} جميع الحقوق محفوظة – مؤسسة إدارة حسابات التواصل الاجتماعي
          </p>
          <div className="flex items-center justify-center gap-4 text-sm">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-orange-500 transition-colors duration-300"
              style={{ fontFamily: 'Cairo, sans-serif' }}
            >
              Powered by CSIT
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}